import API from '@/api'
import Vue from 'vue'
import snack from '@/helpers/snack'
import { getClientBonus } from '@/api/clientsSegments'

export default {
  sendNotifyToSegment({ state }, payload) {
    return API.clientsSegments.sendNotifyToSegment({
      ...payload,
      search: state.selectedSegmentForSend.value.split('|')[0],
      searchFields: state.selectedSegmentForSend.value.split('|')[1],
      searchJoin: 'and',
    })
  },
  getClientsCountInSegment({ state, commit }) {
    commit('changeClientsInSelectedSegment', -1)

    API.clientsSegments
      .getClientsCountInSegment({
        search: state.selectedSegmentForSend.value.split('|')[0],
        searchFields: state.selectedSegmentForSend.value.split('|')[1],
        searchJoin: 'and',
      })
      .then(({ data }) => {
        commit('changeClientsInSelectedSegment', data.amount)
      })
  },
  createNewSegment({ state, commit, dispatch }) {
    const { name } = state.newSegmentForm
    const value = Object.keys(state.segmentsParams).length
      ? `${state.segmentsParams.search}|${state.segmentsParams.searchFields}`
      : `|`

    if (state.segments.some(item => item.name === name)) {
      Vue.notify({
        group: 'hasBottomNavigation',
        type: 'error',
        text: 'Сегмент с таким названием уже существует',
      })

      return
    }

    return API.clientsSegments
      .createSegment({
        ...state.newSegmentForm,
        value,
      })
      .then(() => {
        dispatch('getSegments')

        Object.keys(state.newSegmentForm).forEach(key => {
          commit('changeNewSegmentForm', {
            key,
            value: '',
          })
        })

        Vue.notify({
          group: 'hasBottomNavigation',
          type: 'success',
          text: 'Сегмент успешно создан',
        })
      })
      .catch(() => {
        Vue.notify({
          group: 'hasBottomNavigation',
          type: 'error',
          text: 'При создании сегмента произошла ошибка',
        })
      })
      .finally(() => {
        commit('changeCreateSegmentModalIsActive', false)
      })
  },
  getSegments({ commit }) {
    return API.clientsSegments.getSegments().then(({ data }) => {
      commit('changeSegments', data)
      return Promise.resolve()
    })
  },
  updateSegment({ commit, dispatch }, { data, id }) {
    API.clientsSegments.updateSegment({ data, id }).then(() => {
      dispatch('getSegments')
    })
  },
  deleteSegment({ commit, dispatch }, payload) {
    API.clientsSegments
      .deleteSegment(payload)
      .then(() => {
        dispatch('getSegments')

        Vue.notify({
          group: 'hasBottomNavigation',
          type: 'success',
          text: 'Сегмент успешно удален',
        })
      })
      .catch(() => {
        Vue.notify({
          group: 'hasBottomNavigation',
          type: 'error',
          text: 'При удалении сегмента произошла ошибка',
        })
      })
  },
  async getSegmentsLogs() {
    try {
      const data = await API.clientsSegments.getSegmentsLogs()

      return {
        items: data.map(item => ({
          ...item,
          segmentName: item.segment?.name,
          senderName: `${item.last_name} ${item.first_name}`,
        })),
        count,
      }
    } catch (error) {
      snack.add('Ошибка загрузки истории')
    }
  },
  async getSegmentSendingStat(context, logId) {
    try {
      const { data } = await API.clientsSegments.getSegmentSendingStat({
        batch_id: logId,
      })

      return data
    } catch (error) {
      snack.add('Ошибка загрузки статистики')
    }
  },
  async getSegmentFullStat(context, logId) {
    try {
      const { data } = await API.clientsSegments.getSegmentFullStat(logId)

      return data
    } catch (error) {
      snack.add('Ошибка загрузки статистики')
    }
  },
  async getClientBonus(context, logId) {
    try {
      const { data } = await API.clientsSegments.getClientBonus(logId)

      return data.data
    } catch (error) {
      snack.add('Ошибка загрузки статистики')
    }
  },
}
